import React, {useState, useCallback, useContext, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { USER, UPDATE_USER } from './queries';
import { ButtonContainer } from './elements';
import AssignUserRoles from './AssignUserRoles';

const EditUser = ({setShowModal, refetch, user}) => {
  const { currentUser } = useContext(AuthContext);
  const [submitting, setSubmitting] = useState();
  const [selectedRoles, setSelectedRoles] = useState(user.userRoles || []);
  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['userRoles'] = selectedRoles;
    updateUser({ variables: input });
  });

  // const [ loadUser, { loading: loading, data: data } ] =
  // useLazyQuery(USER, {onCompleted: refetch});

  // if (user === undefined && id && !loading) {
  //   loadUser({ variables: { id } });
  // }

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      id: user?.id,
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
      email: user?.email || '',
      phoneNumber: user?.phoneNumber?.formatted || '',
      role: user?.role || 'Lot',
      receivesReleases: user?.receivesReleases || false,
      canApproveBuyer: user?.canApproveBuyer || false,
      availableForChat: user?.availableForChat || false
    }
  });

  const watchReceivesReleases = watch("receivesReleases");

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Email is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "The email should have at most 50 characters",
                matchPattern: (v) =>
                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                  "Email address must be a valid address",
              },
            })}
          />
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.RolePicker
            label="Role:"
            name="role"
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Receives Releases?"
            name="receivesReleases"
            checked={watchReceivesReleases}
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Available For Chat?"
            name="availableForChat"
            control={control}
            errors={errors}
          />
          <AssignUserRoles
            selectedRoles={selectedRoles}
            setSelectedRoles={setSelectedRoles}
          />
          {currentUser?.canApproveBuyer && (
            <Input.Checkbox
              label="Can Approve Buyers?"
              name="canApproveBuyer"
              control={control}
              errors={errors}
            />
          )}
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update User" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditUser;
